export default __webpack_public_path__ + "static/media/Thumbs.c36ff989.db";